"use client";
import { useState } from "react";

const links = [
  { label: "Education", href: "#education" },
  { label: "Systems", href: "#systems" },
  { label: "Freqtrade", href: "#freqtrade" },
  { label: "Store", href: "#store" },
  { label: "Membership", href: "#membership" },
  { label: "Blog", href: "#blog" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-bg/80 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="/" className="text-xl font-bold tracking-tight">
          <span className="text-gold">HOOD</span>COINS
        </a>
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="text-sm text-silver hover:text-white transition">
              {l.label}
            </a>
          ))}
          <a href="#membership" className="px-4 py-2 bg-gold text-bg text-sm font-semibold rounded hover:bg-gold-dark transition">
            Get Started
          </a>
        </div>
        <button onClick={() => setOpen(!open)} className="md:hidden text-white" aria-label="Menu">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {open ? <path strokeLinecap="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /> : <path strokeLinecap="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />}
          </svg>
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-panel border-t border-white/5 px-6 py-4 space-y-3">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-silver hover:text-white">
              {l.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
